angular
  .module('notify', [])
  .config(['$provide', function ($provide) {
    'use strict';

    // TODO: Eventually it might be nice if we could include different notification systems on different pages
    // TODO: Can we move this to a regular factory?

    //a service to wrap noty and prevent direct plugin interaction in modules
    $provide.factory('notify', function() {
      // if(!window.noty){ alert('jquery noty plugin required'); return false; }

      return {
        //TODO: make this a protected method
        show : function (msg, timeout, modal, type) {
          var messageTemplate = {
            'default': '<span class="msg">' + msg + '</span> <span class="close">&times;</span>',
            'modal': '<span class="msg">' + msg + '</span>'
          };
          var closeWith = ['click'];
          var template = messageTemplate['default'];

          if (modal) {
            template = messageTemplate.modal;
            closeWith = [];
          }

          var notification = noty({
            text: template,
            type: type || 'information',
            dismissQueue: true,
            layout: 'top',
            timeout: timeout || false,
            theme: 'aptitudeTheme',
            modal: modal || false,
            closeWith: closeWith
          });

          //return a method to close the instance without directly interacting with noty
          //if this turns problematic we could get the id from the instance and call $.noty.close(id)
          return { close: function(){ notification.close(); } };
        },

        closeAll: function(){
          $.noty.closeAll();
        },
        //TODO: UX wants the bgcolor for information to not be gray
        info : function (msg, timeout, modal) {
          return this.show(msg, timeout, modal, 'information');
        },

        warn : function (msg, timeout, modal) {
          return this.show(msg, timeout, modal, 'warning');
        },

        error : function (msg, timeout, modal) {
          return this.show(msg, timeout, modal, 'error');
        },

        success : function (msg, timeout, modal) {
          timeout = timeout || 2000;
          return this.show(msg, timeout, modal, 'success');
        }
      };
    });
  }]);
